import React from 'react'
import { Offer } from 'src/core/models'
import { expireOffer } from 'src/features'
import { CustomTag } from 'src/components'
import { useAppDispatch } from 'src/app/hooks'
import { getOfferStatus } from 'src/core/helpers'

const OfferStatusColumn: React.FC<{ offer: Offer }> = ({ offer }) => {
  const dispatch = useAppDispatch()
  const handleExpireOffer = (o: Offer) => dispatch(expireOffer(o.id))
  const status: string = getOfferStatus(offer, handleExpireOffer)

  const tagType = {
    expired: 'default',
    accepted: 'success',
    cancelled: 'error',
    active: 'processing'
  }[offer.state] || 'default'

  return <div className='centered-div'>
    <CustomTag text={status} type={tagType} showIcon={false} />
  </div>
}

export default OfferStatusColumn
